import { render } from "./Course.vue?vue&type=template&id=5cac0e20&scoped=true"
import script from "./Course.vue?vue&type=script&lang=js"
export * from "./Course.vue?vue&type=script&lang=js"

import "./Course.vue?vue&type=style&index=0&id=5cac0e20&scoped=true&lang=css"
import "./Course.vue?vue&type=style&index=1&id=5cac0e20&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cac0e20"]])

export default __exports__